import { ConfigProvider, ThemeConfig } from 'antd';
import React from "react"
import ErrorBoundary from './src/components/ErrorBoundary';
import FeniciaContextProvider from "./src/context/FeniciaContextProvider"
import type { GatsbyBrowser } from "gatsby"
import './src/styles/global.css'

const theme : ThemeConfig = {
  token:{
    colorPrimary:"#ff005d",
    borderRadius: 8
  }
}

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
})  => (
  <ErrorBoundary>
  <FeniciaContextProvider>
    <ConfigProvider theme={theme}>
    {element}
    </ConfigProvider>
  </FeniciaContextProvider>    
  </ErrorBoundary>
)
export const onClientEntry = () => {
  const script = document.createElement("script");
  script.innerHTML = `
    var _smartsupp = _smartsupp || {};
    _smartsupp.key = 'aa47c62c409a89d9067f57a283b95e7ba95bd6ce';
    window.smartsupp||(function(d) {
      var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];
      s=d.getElementsByTagName('script')[0];c=d.createElement('script');
      c.type='text/javascript';c.charset='utf-8';c.async=true;
      c.src='https://www.smartsuppchat.com/loader.js?';s.parentNode.insertBefore(c,s);
    })(document);
  `;
  document.head.appendChild(script);
};